import React from "react";

function SchoolMap() {
  return (
    <div style={{ width: "100%", height: "450px", marginTop: "20px" }}>
      <iframe
        title="ACE International Academy Location"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3324.667948614916!2d73.11419737445875!3d33.56200264345939!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfece150e187e9%3A0xf799459deca9ac4d!2sACE%20International%20Academy!5e0!3m2!1sen!2s!4v1747289384240!5m2!1sen!2s"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}

export default SchoolMap;
